import { useState } from "react";
import { Info, RefreshCw } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

interface DashboardCardActionsProps {
  content: string;
  onRefresh?: () => void | Promise<void>;
  isRefreshing?: boolean;
  className?: string;
}

const actionButtonClass =
  "inline-flex h-6 w-6 items-center justify-center rounded-full text-muted-foreground/60 hover:text-muted-foreground hover:bg-muted/60 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

export function DashboardCardActions({
  content,
  onRefresh,
  isRefreshing = false,
  className,
}: DashboardCardActionsProps) {
  const [popoverOpen, setPopoverOpen] = useState(false);

  return (
    <div
      className={cn(
        "absolute top-3 right-3 sm:top-4 sm:right-4 z-10 flex items-center gap-0.5",
        className,
      )}
    >
      <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
        <Tooltip open={popoverOpen ? false : undefined} delayDuration={300}>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <button type="button" aria-label="Informações sobre esta métrica" className={actionButtonClass}>
                <Info className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              </button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent side="left" align="end" className="max-w-[280px] text-xs leading-relaxed">
            {content}
          </TooltipContent>
        </Tooltip>
        <PopoverContent side="left" align="end" className="max-w-[280px] text-xs leading-relaxed">
          {content}
        </PopoverContent>
      </Popover>

      {onRefresh && (
        <Tooltip delayDuration={300}>
          <TooltipTrigger asChild>
            <button
              type="button"
              aria-label="Atualizar"
              disabled={isRefreshing}
              onClick={() => void onRefresh()}
              className={cn(actionButtonClass, isRefreshing && "pointer-events-none")}
            >
              <RefreshCw className={cn("h-3.5 w-3.5 sm:h-4 sm:w-4", isRefreshing && "animate-spin")} />
            </button>
          </TooltipTrigger>
          <TooltipContent side="left" align="end" className="text-xs">
            Atualizar
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
